import React from 'react'; // jshint ignore:line
import ReactDOM from 'react-dom';
import FormFornisciServizio from './frontend/form-fornisci-servizio'; // jshint ignore:line

document.addEventListener('DOMContentLoaded', () => {
	ReactDOM.render(
		<FormFornisciServizio />,
		document.getElementById('form-iscrizione-servizio')
	);
});
